// extracted by mini-css-extract-plugin
export default {"remove-button":"receiptEmails_remove-button__MkzDA","addEmail":"receiptEmails_addEmail__Qt8VJ"};